module.exports = __webpack_public_path__ + "static/media/course-details-bg.236eeed7.webp";